// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import applicationReleaseEntity from './entities/application-release.json';
import applicationReleaseMenu from '../pages/application-release/menu.json';
import applicationReleaseFullForm from '../pages/application-release/forms/full.json';
import applicationReleaseContextForm from '../pages/application-release/forms/context.json';
import applicationReleaseMiniForm from '../pages/application-release/forms/mini.json';
import applicationReleaseLookupForm from '../pages/application-release/forms/lookup.json';
import applicationReleaseTableView from '../pages/application-release/views/table.json';
import applicationReleaseCardsView from '../pages/application-release/views/cards.json';
import applicationReleaseDashboardView from '../pages/application-release/views/dashboard.json';

/** Тип запису «Випуск» зі сторінками пакета: меню, форми та подання з pages/application-release/. */
export const applicationReleaseDefinition: IRecordTypeDefinition = {
  ...applicationReleaseEntity,
  views: assembleViewSet({
      table: applicationReleaseTableView,
      cards: applicationReleaseCardsView,
      dashboard: applicationReleaseDashboardView,
  }),
  form: applicationReleaseFullForm,
  forms: { full: applicationReleaseFullForm, context: applicationReleaseContextForm, mini: applicationReleaseMiniForm, lookup: applicationReleaseLookupForm },
  menu: applicationReleaseMenu,
} as IRecordTypeDefinition;
